import React from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Tooltip,
  Box,
} from "@mui/material";
import EventAvailableIcon from "@mui/icons-material/EventAvailable";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import BlockIcon from "@mui/icons-material/Block";
import PauseCircleIcon from "@mui/icons-material/PauseCircle";
import CountUp from "react-countup";

const StatCard = ({ item }) => (
  <Tooltip title={item.tooltip} arrow placement="top">
    <Card
      sx={{
        p: 2,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        borderRadius: 3,
        boxShadow: 3,
        height: 120,
      }}
    >
      <Box display="flex" alignItems="center" gap={2}>
        <Box
          sx={{
            bgcolor: item.bgColor,
            color: item.iconColor,
            borderRadius: "50%",
            width: 70,
            height: 70,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {item.icon}
        </Box>
        <Box>
          <Typography variant="body2" color="text.secondary">
            {item.label}
          </Typography>
          <Typography variant="h6" fontWeight="bold" fontSize={28}>
            <CountUp
              start={0}
              end={Number(item.value.toString().replace(/\s/g, ""))} // handle numbers with spaces
              duration={1.5}
              separator=" "
            />
          </Typography>
        </Box>
      </Box>
    </Card>
  </Tooltip>
);

const PlatformActivity = () => {
  const activite = [
    {
      label: "Cours réservés",
      value: 326,
      icon: <EventAvailableIcon fontSize="large" />,
      iconColor: "#1976d2",
      bgColor: "#e3f2fd",
      tooltip: "Cours réservés dans la période",
    },
    {
      label: "Cours effectués",
      value: 305,
      icon: <DoneAllIcon fontSize="large" />,
      iconColor: "#2e7d32",
      bgColor: "#e8f5e9",
      tooltip: "Cours marqués comme faits",
    },
    {
      label: "No-shows",
      value: 21,
      icon: <BlockIcon fontSize="large" />,
      iconColor: "#d32f2f",
      bgColor: "#ffebee",
      tooltip: "Cours sans présence",
    },
    {
      label: "Clients inactifs",
      value: 84,
      icon: <PauseCircleIcon fontSize="large" />,
      iconColor: "#9e9e9e",
      bgColor: "#f5f5f5",
      tooltip: "Aucune réservation depuis 14 jours",
    },
  ];

  return (
    <Grid container spacing={2} mb={3}>
      {activite.map((item, i) => (
        <Grid item xs={12} sm={6} md={3} key={i}>
          <StatCard item={item} />
        </Grid>
      ))}
    </Grid>
  );
};

export default PlatformActivity;
